import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/energebasic',
    name: 'PUT_ENERGEBASIC',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
